<div class="spinner-container initialized" *ngIf="active">
					<div class="spinner"></div>
				</div>